import reportError from 'src/libs/reportError';

window.onerror = (event: Event | string, source: string, fileno: number, columnNumber: number, error: Error) => {
	reportError(error, 'uncaughtException');
};
